import { useState } from "react";
import { Link } from "react-router-dom";


export default function MostOrderedSection() {
  const products = [
    { label: "Tshirt", src: "/tshirts/ob1.png" },
    { label: "Polo Tshirt", src: "/polo/pc1.png" },
    { label: "Sweatshirt", src: "/hoodies/sbr5.png" },
    { label: "Hoodie", src: "/hoodies/hp1.png" },
    { label: "Varsity", src: "/jackets/vb1.png" },
    { label: "Zipper", src: "/hoodies/hdb5.png" },
    { label: "Tote Bag", src: "/hoodies/bag2.png" },
    { label: "Cap", src: "/hoodies/snapBack1.png" },
  ];

  const [activeIndex, setActiveIndex] = useState(4);

  return (
    <section
      className="w-full bg-white overflow-hidden"
      style={{
        paddingLeft: "4vw",
        paddingRight: "4vw",
      }}
    >
      {/* ================= CONTAINER ================= */}
      <div
        style={{
          width: "100%",
          paddingTop: "0px",
          paddingBottom: "64px",
        }}
      >
        {/* ================= TOP FEATURES ================= */}
        <div className="grid grid-cols-1 md:grid-cols-3 border-b border-gray-200">
          {[
            { text: "Fast Delivery", icon: "/(1).png" },
            { text: "Access to Private Design Portal", icon: "/(2).png" },
            { text: "Unlimited Design Requests", icon: "/(3).png" },
          ].map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-5 px-4 md:px-8 py-4 md:py-6 border-r last:border-r-0"
            >
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                <img
                  src={item.icon}
                  alt=""
                  className="w-8 h-8 object-contain"
                />
              </div>

              <p className="text-sm font-medium text-gray-700">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* ================= HEADER ================= */}
        <div className="pt-6 flex flex-col md:flex-row justify-between items-start gap-8">
          <h2
            style={{
              fontFamily: "'PP Neue Montreal', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(36px, 4.5vw, 60px)",
              lineHeight: "1.18",
              letterSpacing: "0.05em",
              color: "#0b0b0b",
            }}
          >
            <span style={{ display: "block" }}>Apparel Teams</span>
            <span style={{ display: "block" }}>Actually Wear</span>
          </h2>

          <div className="max-w-sm">
            <p className="text-[16px] leading-[1.7] text-gray-500 mb-6 font-['Montserrat']">
              Our most requested silhouettes — chosen for comfort,
              durability, and everyday wear beyond the workplace.
            </p>

            <Link
  to="/products"
  className="inline-block bg-orange-500 text-black px-7 py-3 text-sm font-medium"
>
  View All
</Link>

          </div>
        </div>

        {/* ================= PRODUCT RAIL ================= */}
        <div className="mt-12">
          <div className="flex items-end h-[420px] md:h-[550px]">
            {products.map((item, index) => {
              const isActive = index === activeIndex;

              return (
                <div
                  key={index}
                  onMouseEnter={() => setActiveIndex(index)}
                  className="relative transition-all duration-500 ease-in-out"
                  style={{
                    width: isActive ? "38%" : "9%",
                    height: "100%",
                  }}
                >
                  <img
                    src={item.src}
                    alt={item.label}
                    className={`w-full h-full object-cover object-top transition-all duration-500 ${
                      isActive ? "brightness-100" : "brightness-75"
                    }`}
                  />

                  {!isActive && (
                    <span
                      className="absolute bottom-12 left-1/2 text-white text-[18px] md:text-[24px] tracking-wider font-medium"
                      style={{
                        writingMode: "vertical-rl",
                        transform: "translateX(-50%) rotate(180deg)",
                      }}
                    >
                      {item.label}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
